<template>
    <div class="flex flex-col pt-8 bg-white rounded md:pt-14 shadow-wide">
        <img class="w-full mb-4 md:mb-8" :src="imageUrl" alt="" />

        <div class="px-3 pb-3 text-center">
            <h3 class="text-lg font-bold leading-snug text-blue-500 md:text-xl">{{ title }}</h3>
            <p class="mt-2 text-grey-500 small">{{ modelNumber }}</p>
        </div>

        <div class="flex mt-auto border-t border-blue-100">
            <div class="flex flex-col items-center justify-center w-1/2 p-4">
                <p class="text-blue-500">{{ priceFormatted }}</p>
                <p class="text-grey-500 small">RRP</p>
            </div>
            <div
                class="flex flex-col items-center justify-center w-1/2 p-4 border-l border-blue-100"
            >
                <p class="text-blue-500">{{ memberPriceFormatted }}</p>
                <p class="text-grey-500 small">Members</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        imageUrl: {
            type: String,
            required: true
        },
        modelNumber: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        priceFormatted: {
            type: String,
            required: true
        },
        memberPriceFormatted: {
            type: String,
            required: true
        }
    },

    data: () => ({}),

    computed: {},

    methods: {}
};
</script>
